import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_WATCH_LIST_ENTRIES } from "../types";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";
import {
  getWatchListEntriesPending,
  getWatchListEntriesFulfilled,
  getWatchListEntriesRejected,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { watchListEntriesFiltersSelector } from "../selectors";
import generateError from "../../../utilities/generateError";
import { setNoEntriesMessage } from "../actions";
const createPayload = (payload) => ({
  method: "get",
  url: "watchlistentry/search",
  onSuccess: [
    getWatchListEntriesFulfilled,
    (response) =>
      response.data.length === 0
        ? setNoEntriesMessage(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
        : { type: "" },
  ],
  onError: [
    getWatchListEntriesRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getWatchListEntriesEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_WATCH_LIST_ENTRIES.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = watchListEntriesFiltersSelector(state$.value);

      return merge(
        of(getWatchListEntriesPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getWatchListEntriesEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListEntriesEpic.js